import {ScreenProp} from 'src/app/models'

type TKeys = 'KALENDER' | 'KALENDER_LIST'

export const KalenderJobScreen: Record<TKeys, ScreenProp> = {
  KALENDER: {
    PATH: '/calendar',
    TITLE: 'Kalender Tugas',
    TITLE_ALT: 'Kalender Tugas',
  },
  KALENDER_LIST: {
    PATH: '/calendar/list',
    TITLE: 'Kalender Tugas',
    TITLE_ALT: 'Kalender Tugas',
  },
}
